import React from "react";
import ReactDOM from "react-dom/client";

const Button = () => {
    return <button>Buttonsdddddddddddddddddddddd</button>;
};

const button = document.querySelector(".react-button");
if (button) {
    const root = ReactDOM.createRoot(button);
    root.render(<Button />);


}